/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Tabs_AriaInputs */

const en_directory_submit_tabs_aria = /** @type {(inputs: Directory_Submit_Tabs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submission type`)
};

const zh_directory_submit_tabs_aria = /** @type {(inputs: Directory_Submit_Tabs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交类型`)
};

/**
* | output |
* | --- |
* | "Submission type" |
*
* @param {Directory_Submit_Tabs_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_tabs_aria = /** @type {((inputs?: Directory_Submit_Tabs_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Tabs_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_tabs_aria(inputs)
	return zh_directory_submit_tabs_aria(inputs)
});
export { directory_submit_tabs_aria as "directory.submit.tabs_aria" }